<h2 mat-dialog-title>Transaction presets</h2>

<mat-dialog-content class="preset-editor">
  <div class="list" *ngIf="!isLoading; else loading">
    <div
      class="preset-row"
      *ngFor="let preset of presets"
      (click)="selectPreset(preset)"
      [class.active]="editing._id === preset._id">
      <div class="name">{{ preset.name }}</div>
      <div class="meta">
        <span class="pill">{{ preset.atocategory || 'uncategorised' }}</span>
        <span class="pill ghost" *ngIf="preset.hasGST">GST</span>
        <span class="pill warn" *ngIf="preset.requiresEvidence">Requires evidence</span>
      </div>
    </div>
    <button mat-stroked-button color="primary" (click)="startNew()">New preset</button>
  </div>

  <div class="editor" *ngIf="!isLoading">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="editing.name">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>ATO Category</mat-label>
      <mat-select [(ngModel)]="editing.atocategory">
        <mat-option *ngFor="let cat of categories" [value]="cat.value">{{ cat.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="editing.hasGST">Has GST</mat-checkbox>
    <mat-checkbox [(ngModel)]="editing.requiresEvidence">Requires evidence</mat-checkbox>

    <div class="patterns">
      <div class="patterns-header">
        <div>
          <div class="title">Patterns</div>
          <div class="hint">
            Use named groups like <code>?&lt;date&gt;</code> or <code>?&lt;order&gt;</code>.
            Example:
            <code>Visa Purchase\s+(?&lt;date&gt;\d&#123;2&#125;[A-Za-z]&#123;3&#125;)</code>
          </div>
        </div>
        <button mat-stroked-button color="primary" type="button" (click)="addPattern()">Add pattern</button>
      </div>
      <div class="pattern-row" *ngFor="let pattern of editing.patterns; let i = index">
        <mat-form-field appearance="outline">
          <mat-label>Regex pattern</mat-label>
          <input matInput [(ngModel)]="pattern.pattern" placeholder="e.g. Visa Purchase\s+(?<date>\d{2}[A-Za-z]{3})">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Flags</mat-label>
          <input matInput [(ngModel)]="pattern.flags" placeholder="i">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Example</mat-label>
          <input matInput [(ngModel)]="pattern.example" placeholder="Optional note or sample line">
        </mat-form-field>
        <button mat-icon-button color="warn" (click)="removePattern(i)" [disabled]="isSaving">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <div class="actions">
      <button mat-stroked-button (click)="startNew()">Clear</button>
      <button mat-stroked-button color="warn" (click)="delete(editing)" [disabled]="!editing._id || isSaving">Delete</button>
      <span class="spacer"></span>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving || !editing.name || !editing.atocategory">
        {{ editing._id ? 'Update' : 'Create' }} preset
      </button>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading">Loading presets...</div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>